<template>
    <v-dialog
        v-model="$props.params.informationConnectedUsersAddEquipmentDialog"
        transition="dialog-bottom-transition"
        max-width="600px"
        @keydown.esc="closeInformationConnectedUsersAddEquipmentDialog()"
        @click:outside="closeInformationConnectedUsersAddEquipmentDialog()"
    >
        <v-card>
            <v-form @submit.prevent="processInformationConnectedUsersAddEquipmentUnderUser()">

                <v-toolbar
                    color="primary"
                    dark
                    :class="dialogHeadingClasses()"
                >
                    <v-icon v-text="icons.mdiPlusCircleOutline" class="mr-3"></v-icon>
                    {{ $gettext('Add equipment') }}
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeInformationConnectedUsersAddEquipmentDialog()" v-text="icons.mdiClose"></v-icon>
                    <!--                    <v-icon @click.native.stop="processInformationConnectedUsersAddEquipmentUnderUser()" v-text="icons.mdiContentSave"></v-icon>-->
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-4">
                    <v-container>
                        <v-row>
                            <v-col class="subtitle-1">

                                <v-text-field
                                    :label="$gettext('Equipment name')"
                                    :placeholder="$gettext('Equipment name')"
                                    required
                                    v-model="deviceName"
                                    outlined
                                    clearable
                                    autofocus
                                    :error-messages="deviceNameErrors"
                                    @input="$v.deviceName.$touch()"
                                    @blur="$v.deviceName.$touch()"
                                    :hint="'Mac address: '+$props.params.mac"
                                    persistent-hint
                                >
                                </v-text-field>

                                <v-switch v-model="existingUserOrNewUser" :true-value="true" :false-value="false"
                                          :label="existingUserOrNewUser ? $gettext('Add this equipment for an existing user') : $gettext('Add this equipment for a new user')"></v-switch>

                                <v-autocomplete
                                    v-if="!existingUserOrNewUser"
                                    :label="$gettext('Choose account group')"
                                    :placeholder="$gettext('Choose account group')"
                                    outlined
                                    clearable
                                    v-model="chosenUserGroup"
                                    :items="configUserPrepareAnArrayForAutocompleteOfUserGroup()"
                                    :error-messages="chosenUserGroupErrors"
                                    @input="$v.chosenUserGroup.$touch()"
                                    @blur="$v.chosenUserGroup.$touch()"
                                >
                                </v-autocomplete>

                                <v-text-field
                                    v-if="!existingUserOrNewUser"
                                    :label="$gettext('User name')"
                                    :placeholder="$gettext('User name')"
                                    required
                                    v-model="userName"
                                    outlined
                                    clearable
                                    :error-messages="userNameErrors"
                                    @input="$v.userName.$touch()"
                                    @blur="$v.userName.$touch()"
                                >
                                </v-text-field>

                                <v-autocomplete
                                    v-else
                                    :label="$gettext('Choose user')"
                                    :placeholder="$gettext('Choose user')"
                                    outlined
                                    clearable
                                    v-model="chosenUser"
                                    :items="prepareAnArrayForUserAutocompleteAlongWithUserGroup(users)"
                                    item-text="userKey"
                                    :error-messages="chosenUserErrors"
                                    @input="$v.chosenUser.$touch()"
                                    @blur="$v.chosenUser.$touch()"
                                    return-object
                                >
                                    <template v-slot:item="{ item }">
                                        <v-list-item-title class="d-flex">
                                            {{ item.userKey }} <span class="ml-auto caption text-right" v-text="item.userGroupKey"></span>
                                        </v-list-item-title>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native.stop="closeInformationConnectedUsersAddEquipmentDialog()">
                        {{ $gettext('Close') }}
                    </v-btn>
                    <v-btn color="primary" type="submit">
                        {{ $gettext('Add Equipment') }}
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <snackbar ref="snackbar"></snackbar>
    </v-dialog>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import Vue from 'vue'

import Vuelidate from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigRules from '@/mixins/database/MixinConfigRules'
import MixinLodashPadStart from '@/mixins/lodash/MixinLodashPadStart'
import { mapState, mapWritableState } from 'pinia'
import { useConnectionsStore } from '@/stores/ConnectionsStore'
import { useProgressBarsStore } from '@/stores/ProgressBarStore'
import { useRulesStore } from '@/stores/RulesStore'
import { useGroupsStore } from '@/stores/GroupsStore'
import { useCategoriesStore } from '@/stores/CategoriesStore'
import MixinConfig from '@/mixins/database/MixinConfig'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import ProgressBar from '@/components/ProgressBar'
import { useUsersStore } from '@/stores/UsersStore'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'

Vue.use(Vuelidate)

export default {
    components: { Snackbar, ProgressBar },
    mixins: [MixinConfig, MixinDialog, MixinIcon, MixinStringManipulation, MixinGenericComponent, MixinConfigUsers],
    props: {
        params: {
            required: true,
            type: Object | Array,
        },
    },
    mounted () {

    },
    data () {
        return {
            existingUserOrNewUser: true,
            userName: '',
            chosenUser: '',
            deviceName: '',
            chosenUserGroup: '',
        }
    },

    methods: {

        async processInformationConnectedUsersAddEquipmentUnderUser () {

            let self = this

            self.$v.$touch()

            // this seems to get the validation process a start, and we then wait as the isUnique check is a promise.
            await self.$v.$invalid
            await self.$v.$invalid // safety net
            await self.$nextTick() // safety net

            if ( ! self.$v.$invalid) {

                const deviceToBeAdded = {
                    key: self.deviceName,
                    value: {
                        active: 1,
                        mac: self.$props.params.mac
                    }
                }

                if ( ! self.existingUserOrNewUser) {

                    self.addUserUnderCategoryToDatabase(self.chosenUserGroup, {
                        key: self.userName,
                        value: {
                            devices: [deviceToBeAdded],
                        }
                    })

                    self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('User, %{ userName } and device, %{ deviceName } is added successfully'), {
                        userName: self.userName,
                        deviceName: self.deviceName
                    }))
                    self.closeInformationConnectedUsersAddEquipmentDialog()

                } else {

                    const userGroupKey = self.chosenUser.userGroupKey

                    if ( ! userGroupKey) {
                        self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! error occurred, the device was not added. Please try again in some time.'), 'error')
                    } else {

                        if (self.configUserHasDeviceUnderUser(self.chosenUser.userKey, deviceToBeAdded.key)) {
                            self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('It appears this device is already added for %{user}'), { user: self.chosenUser.userKey }), 'error')
                        } else {
                            self.configUserAddUserChildNode(userGroupKey, self.chosenUser.userKey, deviceToBeAdded, 'devices')
                            self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Device %{ deviceName }, was added successfully for %{ user }'), {
                                deviceName: self.deviceName,
                                user: self.chosenUser.userKey
                            }))
                            self.closeInformationConnectedUsersAddEquipmentDialog()
                        }

                    }
                }
            }
        },
        closeInformationConnectedUsersAddEquipmentDialog () {
            let self = this
            const connectedUsersComponent = self.genericComponentGetComponent('ConnectedUsers')
            connectedUsersComponent.closeDialog('informationConnectedUsersAddEquipmentDialog')
        },
        resetForm () {

            let self = this
            self.$v.$reset()
            self.existingUserOrNewUser = true
            self.userName = ''
            self.chosenUser = ''
            self.deviceName = ''
            self.chosenUserGroup = ''

        },
    },
    computed: {

        ...mapState(useUsersStore, {
            users: 'users',
        }),

        deviceNameErrors () {

            const errors = []
            if ( ! this.$v.deviceName.$dirty) return errors

            ! this.$v.deviceName.required && errors.push(this.$gettext('Equipment name is required'))
            ! this.$v.deviceName.isUnique && errors.push(this.$gettextInterpolate(this.$gettext('We already have a device with this name, for %{user} please choose another name.'), { user: this.chosenUser.userKey }))
            return errors

        },
        chosenUserErrors () {

            const errors = []
            if ( ! this.$v.chosenUser.$dirty) return errors
            ! this.$v.chosenUser.required && errors.push(this.$gettext('Please choose a user'))
            return errors

        },
        userNameErrors () {
            const errors = []
            if ( ! this.$v.userName.$dirty) return errors
            ! this.$v.userName.required && errors.push(this.$gettext('Please provide a user name'))
            ! this.$v.userName.isUnique && errors.push(this.$gettextInterpolate(this.$gettext('This user already exists under %{userGroup}'), { userGroup: this.chosenUserGroup }))
            return errors
        },
        chosenUserGroupErrors () {
            const errors = []
            if ( ! this.$v.chosenUserGroup.$dirty) return errors
            ! this.$v.chosenUserGroup.required && errors.push(this.$gettext('Please choose a user group'))
            return errors
        }
    },
    validations: {
        deviceName: {
            required,
            async isUnique (val, vm) {

                if ( ! this.existingUserOrNewUser || ! this.chosenUser) {
                    return true
                }

                await this.$nextTick() // Just to satisfy async method.
                return this.configUserIsDeviceUniqueForUser(val, this.chosenUser.userGroupKey, this.chosenUser.userKey)

            }
        },
        chosenUser: {
            required: requiredIf(function () {
                return this.existingUserOrNewUser
            })
        },
        chosenUserGroup: {
            required: requiredIf(function () {
                return ! this.existingUserOrNewUser
            })
        },
        userName: {
            required: requiredIf(function () {
                return ! this.existingUserOrNewUser
            }),
            async isUnique (val, vm) {

                if (vm.existingUserOrNewUser) {
                    return true
                }

                const hasUser = await (this.configUserHasUserUnderUserGroup(vm.chosenUserGroup, val))
                return ! hasUser
            },
        },
    },
}
</script>
